import { DataService } from './services/data.service';
import { Subject } from 'rxjs/Subject';
import { BusinesLogicService } from './services/business-logic.service';
var AppComponent = (function () {
    function AppComponent(_data, _blogic) {
        this._data = _data;
        this._blogic = _blogic;
        this.logged = false;
        this.turn = {};
        this.showAlert = false;
        this.destroy$ = new Subject();
    }
    AppComponent.prototype.ngOnInit = function () {
    };
    AppComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    AppComponent.prototype.logout = function () {
        window.location.reload();
    };
    AppComponent.prototype.refresh = function () {
        window.location.reload();
    };
    AppComponent.prototype.isContainerVisible = function () {
        return this._data.turn == null;
    };
    return AppComponent;
}());
export { AppComponent };
